import { State } from 'store'

export const getError = (state: State) => state.errors
